import { Box, Divider, Paper } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import { MailBoxContainer, MailMessageListItem, MailMessageListItemButton, MailMessageListItemTextBox, MailMessagesList, MailMessagesListBox, TableStyled } from './style';
import DocumentCardSkeleton from '../../components/DocumentCard/skeleton';

export const skeleton = (
    <>
        {/* <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'fixed', top: '0px', left: '0px', width: '100%', height: '100%', background: 'white' }}>
                <CircularProgress />
            </Box> */}
        <MailBoxContainer>
            {/* Left Side UI */}
            <MailMessagesListBox>
                <Skeleton variant="text" sx={{ height: '2rem', width: '20%', minWidth: '15rem' }} />

                <Box display={'flex'} columnGap={'1rem'} flexWrap={'wrap'} marginTop={'1rem'}>
                    {Array.from(Array(4).keys()).map((_, index) => (
                        <Skeleton key={index} variant="text" width={'45%'} height={'1.5rem'} />
                    ))}
                </Box>

                <Divider
                    sx={(theme) => ({
                        margin: `${theme.typography.generic.xLarge} ${theme.typography.generic.none}`,
                    })}
                />
                <Skeleton variant="rounded" sx={{ height: '2.5rem', minWidth: '13rem', width: '20%' }} />

                <MailMessagesList sx={{ marginTop: '1.5rem' }}>
                    {Array.from(Array(4).keys()).map((cListItem) => (
                        <MailMessageListItem key={cListItem}>
                            <MailMessageListItemButton>
                                <MailMessageListItemTextBox>
                                    <Skeleton variant="text" sx={{ height: '1.2rem', minWidth: '10rem', width: '20%' }} />
                                    <Skeleton variant="text" sx={{ height: '1rem', minWidth: '10rem', width: '80%' }} />

                                    <Box display={'flex'} gap={'0.5rem'} flexWrap={'wrap'} marginTop={'1rem'}>
                                        {Array.from(Array(2).keys()).map((cItem) => (
                                            <Skeleton key={cItem} variant="rounded" sx={{ height: '1.5rem', minWidth: '1rem' }} />
                                        ))}
                                    </Box>
                                </MailMessageListItemTextBox>

                                <Box display={'flex'}>
                                    <Skeleton variant="rounded" sx={{ height: '1rem', minWidth: '1rem' }} />
                                    <Skeleton variant="text" sx={{ height: '1rem', minWidth: '3rem', marginLeft: '0.5rem' }} />
                                </Box>
                            </MailMessageListItemButton>
                        </MailMessageListItem>
                    ))}
                </MailMessagesList>
            </MailMessagesListBox>

            {/* Right Side UI */}

            <Paper
                sx={{
                    width: { xs: '100%', sm: '60%' },

                    display: {
                        xs: 'none',
                        sm: 'block',
                    },
                }}
            >
                <Box height={'100%'} overflow={'auto'}>
                    <Box
                        sx={(theme) => ({
                            padding: {
                                xs: `${theme.typography.generic.xxxLarge} ${theme.typography.generic.xLarge}`,
                                sm: `${theme.typography.generic.xxxLarge} ${theme.typography.generic.xxxLarge}`,
                            },
                        })}
                    >
                        <Skeleton variant="text" sx={{ height: '1rem', width: '30%' }} />
                        <Skeleton variant="text" sx={{ height: '2rem', width: '20%' }} />

                        <Divider sx={(theme) => ({ marginTop: theme.typography.generic.large })} />

                        <Box
                            sx={(theme) => ({
                                marginTop: `${theme.typography.generic.large}`,
                                marginBottom: `${theme.typography.generic.large}`,
                                display: 'flex',
                                // justifyContent: 'space-between',
                                alignItems: 'center',
                            })}
                        >
                            <Skeleton variant="circular" sx={{ height: '3rem', width: '3rem' }} />

                            <Box marginLeft={'0.5rem'}>
                                <Skeleton variant="text" sx={{ height: '1.2rem', width: '10rem' }} />
                                <Skeleton variant="text" sx={{ height: '0.8rem', width: '5rem' }} />
                            </Box>
                        </Box>

                        <Divider />

                        <Box
                            className="Message"
                            overflow={'auto'}
                            padding={(theme) => ({
                                xs: `${theme.typography.generic.xxxLarge} ${theme.typography.generic.none}`,
                                sm: `${theme.typography.generic.xxxLarge} ${theme.typography.generic.none}`,
                            })}
                        >
                            <Skeleton variant="text" sx={{ height: '1.2rem', width: '10rem', marginBottom: '1rem' }} />
                            <Skeleton variant="text" sx={{ height: '1rem', width: '100%' }} />
                            <Skeleton variant="text" sx={{ height: '1rem', width: '100%' }} />
                            <Skeleton variant="text" sx={{ height: '1rem', width: '100%' }} />
                            <Skeleton variant="text" sx={{ height: '1rem', width: '100%' }} />
                            <Skeleton variant="text" sx={{ height: '1rem', width: '100%' }} />
                        </Box>

                        <Divider />
                        <Box
                            padding={(theme) => ({
                                xs: `${theme.typography.generic.xxxLarge} ${theme.typography.generic.xLarge}`,
                                sm: `${theme.typography.generic.xxxLarge} ${theme.typography.generic.xxxLarge}`,
                            })}
                        >
                            <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                {' '}
                                <Skeleton variant="text" sx={{ height: '1.2rem', width: '10rem' }} />
                            </Box>
                            <Box
                                sx={(theme) => ({
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    padding: `${theme.typography.generic.xSmall} ${theme.typography.generic.none}`,
                                    marginLeft: `-${theme.typography.generic.xSmall}`,
                                })}
                            >
                                {Array.from(Array(3).keys()).map((_, index) => (
                                    <DocumentCardSkeleton key={index} />
                                ))}
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Paper>
        </MailBoxContainer>
    </>
);
